// eslint-disable-next-line no-unused-vars
const ON_CHANGE_DEBOUNCE_TIMER = 300

// eslint-disable-next-line no-unused-vars
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityRulesUpdate: 'quantity-rules-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error'
}

// eslint-disable-next-line no-unused-vars
const EWG_REPORT_API_URL = 'https://ewgapi.waterdropfilter.com'
